import React from "react"

const SubTitle = props => (
  <h2 data-sal="slide-down" className="subtitle">
    {props.subtitle}
  </h2>
)

export default SubTitle
